var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8293 2.48766C19.1251 2.79657 18.3746 3.00132 17.5922 3.10076C18.3971 2.62027 19.0114 1.86511 19.3002 0.954866C18.5498 1.40227 17.7212 1.71832 16.8383 1.89462C16.1257 1.13599 15.1102 0.666016 14.0022 0.666016C11.8528 0.666016 10.1223 2.4107 10.1223 4.54954C10.1223 4.8573 10.1483 5.15319 10.2123 5.4349C6.98445 5.27751 4.12835 3.73044 2.20969 1.37382C1.87472 1.955 1.67824 2.62027 1.67824 3.33637C1.67824 4.6809 2.37066 5.87286 3.4028 6.56292C2.77899 6.55105 2.16707 6.37003 1.64865 6.08475C1.64865 6.09661 1.64865 6.11194 1.64865 6.12737C1.64865 8.01402 2.99445 9.58115 4.75929 9.94223C4.44324 10.0286 4.09874 10.07 3.74132 10.07C3.49278 10.07 3.24183 10.0558 3.00631 10.0038C3.50937 11.5413 4.93675 12.6717 6.63417 12.7084C5.31317 13.7417 3.636 14.3643 1.82027 14.3643C1.50188 14.3643 1.19649 14.35 0.891113 14.311C2.61094 15.4201 4.64915 16.0533 6.84721 16.0533C13.9916 16.0533 17.8976 10.1351 17.8976 5.00524C17.8976 4.83367 17.8916 4.66788 17.8834 4.50335C18.6539 3.95651 19.3014 3.27358 19.8293 2.48766Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.9743ba5ac0733581dd84949e1b49665d.svg";
export { ForwardRef as ReactComponent };